import * as Sentry from "@sentry/vue";

export const addSentry = function (app, router) {
   // dont allow sentry under the following conditions
   // note that import.meta.env.MODE is automatically set by Vite (during build, it would be production)
   if (import.meta.env.SSR || (window as any).Cypress || import.meta.env.MODE === "development") return;

   const fullApiPath = `${import.meta.env.VITE_APP_API_BASE_URL}${import.meta.env.VITE_APP_API_PATH}`;
   const fePptNetworkErrorsDSN =
      "https://57450d02c5a8402e5dff8c17e30f10ef@o243783.ingest.us.sentry.io/4508715562303489";

   Sentry.init({
      app,
      dsn:
         import.meta.env.VITE_APP_ORG === "sano"
            ? "https://0bb134cb9aec48dcbf19ecaa115142ed@o243783.ingest.sentry.io/4505369267470336"
            : "https://3a13de56c6a14f659688535af75b028d@o243783.ingest.sentry.io/4505369278808064",
      tracePropagationTargets: [fullApiPath],
      integrations: [
         Sentry.browserTracingIntegration({ router }),
         Sentry.replayIntegration(),
         Sentry.captureConsoleIntegration({
            // array of methods that should be captured
            // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
            levels: ["error", "debug"],
         }),
      ],
      environment: import.meta.env.VITE_SENTRY_MODE,
      transport: Sentry.makeMultiplexedTransport(Sentry.makeFetchTransport, ({ getEvent }) => {
         // Send errors which should / should not be triaged to a different project
         const event = getEvent();
         let shouldBeTriaged = true;

         const isAxios401Error =
            event.message?.includes("AxiosError: Request failed with status code 401") ||
            event.exception?.values?.[0]?.value?.includes("Request failed with status code 401");
         const isAxios50XError =
            event.message?.includes("AxiosError: Request failed with status code 50") ||
            event.exception?.values?.[0]?.value?.includes("Request failed with status code 50");
         const isAxiosAborted =
            event.message?.includes("AxiosError: Request aborted") ||
            event.exception?.values?.[0]?.value?.includes("Request aborted"); // Request timeout - these are typically network issues
         const isAxiosNetworkError =
            event.message?.includes("AxiosError: Network Error") ||
            event.exception?.values?.[0]?.value?.includes("Network Error"); // Network connectivity issues
         const isGALoadError = event.message?.includes("Failed to load the Google Analytics script");
         if (isAxios401Error) event.tags["volumeErrType"] = "Axios 401";
         if (isAxios50XError) event.tags["volumeErrType"] = "Axios 50X";
         if (isAxiosAborted) event.tags["volumeErrType"] = "Axios Aborted";
         if (isAxiosNetworkError) event.tags["volumeErrType"] = "Axios Network Error";
         if (isGALoadError) event.tags["volumeErrType"] = "Google Analytics load fail";

         if (isAxios401Error || isAxios50XError || isGALoadError || isAxiosAborted || isAxiosNetworkError)
            shouldBeTriaged = false;

         if (!shouldBeTriaged) {
            return [{ dsn: fePptNetworkErrorsDSN, release: "VolumeErrors@1.0.0" }];
         } else {
            return [];
         }
      }),
      // using strings looks for partial matches, exact matches require a regex
      // these errors will not be sent to Sentry at all

      // wptagent - a bot logging stuff to console,
      // syntax error 27 - only appears after network error means client settings didn't load,
      // java object is gone - issue in old facebook browser,
      // unable to preload css 🤷
      ignoreErrors: ["wptagent_message", "SyntaxError: 27", "Java object is gone", "Unable to preload CSS"],
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
   });
};
